import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { EnlargedImageCarousel } from "./enlarged-image-carousel.component";

interface EnlargedImageCarouselDialogProps {
  handleClose: () => void;
  isOpen: boolean;
  isLoading: boolean;
  picturePaths: string[] | null;
  /** Runs after the close transition ends; use to clear `picturePaths` without flashing content while closing. */
  onDialogExited?: () => void;
}

export function EnlargedImageCarouselDialog({
  handleClose,
  isOpen,
  picturePaths,
  isLoading,
  onDialogExited
}: Readonly<EnlargedImageCarouselDialogProps>) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={handleClose}
      aria-labelledby="enlarged-image-dialog-label"
      aria-describedby="enlarged-image-dialog-describe"
      maxWidth={"lg"}
      fullWidth={true}
      slotProps={{
        paper: { sx: { height: isMobile ? "70vh" : "unset" } },
        ...(onDialogExited ? { transition: { onExited: onDialogExited } } : {})
      }}
    >
      <DialogTitle data-testid="enlarged-image-dialog-title">{t("Show Images")}</DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
        <EnlargedImageCarousel picturePaths={picturePaths} isLoading={isLoading} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} data-testid="enlarged-image-dialog-close">
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
